import { BeneficiaryInsightWidgetDTO } from '@repo/shared/dtos/beneficiary'
import { useMemo } from 'react'

import { DataTable } from '../../members/data-table'
import { columns } from './columns'
import { Empty } from './Empty'

export function InsightsList({ widgets }: { widgets: BeneficiaryInsightWidgetDTO[] }) {
  const memoizedColumns = useMemo(() => columns, [])

  if (widgets.length === 0) {
    return <Empty />
  }

  return <DataTable columns={memoizedColumns} data={widgets} />
}
